import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

// Order matters. Structural reset first, then the theme's tokens (which define
// every variable), then the theme's skin (which consumes them). A skin loaded
// before its tokens would resolve every var() to nothing.
// 顺序要紧。先结构性 reset，再主题令牌（定义所有变量），最后主题皮肤（消费变量）。
// 皮肤若先于令牌加载，所有 var() 都会解析为空。
import './styles/base.css'
import './themes/bigtech/tokens.css'
import './themes/bigtech/skin.css'

import App from './app/App.jsx'
import { AuthProvider } from './lib/auth.jsx'
import { LanguageProvider } from './lib/i18n.jsx'
import { ThemeProvider } from './lib/theme.jsx'
import { ToastProvider } from './ui/index.js'

/**
 * Application entry point.
 *
 * Provider order is a dependency order, not a preference: ThemeProvider writes
 * the `data-theme-pack` attribute the stylesheets are scoped to, so it wraps
 * everything; LanguageProvider is needed by every string below it; AuthProvider
 * fires the session probe on mount and must sit above the router so the guard
 * can read it; ToastProvider sits innermost because only application code
 * raises toasts.
 *
 * 应用入口。
 *
 * Provider 的嵌套顺序是依赖顺序而非偏好：ThemeProvider 写入样式表所依赖的
 * data-theme-pack 属性，因此包在最外层；LanguageProvider 为其下所有文案服务；
 * AuthProvider 挂载时发起会话探测，必须位于路由之上，守卫才读得到；
 * ToastProvider 在最内层，因为只有业务代码会弹提示。
 */
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ThemeProvider>
      <LanguageProvider>
        <AuthProvider>
          <ToastProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </ToastProvider>
        </AuthProvider>
      </LanguageProvider>
    </ThemeProvider>
  </StrictMode>
)
